import axios from "axios";
import * as Urls from "../constants/Urls";

export const getUser = () => axios.get(Urls.GET_USER_URL);

export const getList = () => axios.get(Urls.GET_USER_LIST_URL);

export const login = (obj) => axios.post(Urls.LOGIN_URL,obj);

export const register = (obj) => axios.post(Urls.REGISTER_URL,obj);

export const rootRegister = (obj) => axios.post(Urls.ROOT_REGISTER_URL,obj);


export const delUser = (id) => axios.delete(Urls.deleteUserUrl(id));